import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.id = parseInt(payload.id, 10)
  payload.group_id = parseInt(payload.group_id, 10)
  payload.service_id = parseInt(payload.service_id, 10)
  payload.tariff_id = parseInt(payload.tariff_id, 10)
  payload.is_enabled = parseInt(payload.is_enabled, 10)
  payload.priority = parseInt(payload.priority, 10)
  payload.multiple_linking = parseInt(payload.multiple_linking, 10)
}

var state = {
  userIndependentServicesConnect: []
}

var getters = {
  INDEPENDENT_SERVICES_CONNECT: (state) => {
    return state.userIndependentServicesConnect
  }
}

var mutations = {
  SET_INDEPENDENT_SERVICES_CONNECT: (state, payload) => {
    state.userIndependentServicesConnect = payload
  }
}

var actions = {
  GET_INDEPENDENT_SERVICES_CONNECT: async (context, payload) => {
    let result = await axiosInstance.get('/settings/independent_connect_services')
    if (result.status === 200) {
      context.commit('SET_INDEPENDENT_SERVICES_CONNECT', result.data)
    }
  },
  CREATE_INDEPENDENT_SERVICES_CONNECT: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/independent_connect_services', payload)
  },
  UPDATE_INDEPENDENT_SERVICES_CONNECT: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/independent_connect_services', payload)
  },
  DELETE_INDEPENDENT_SERVICES_CONNECT: (context, payload) => {
    return axiosInstance.delete('/settings/independent_connect_services?independent_connect_services_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/userIndependentServicesConnect.js